(function () {
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function parseMap(s) {
    var m = {};
    (s || '').split(',').forEach(function (p) {
      p = (p || '').trim();
      if (!p) return;
      var i1 = p.indexOf(':'), i2 = p.indexOf(':', i1 + 1);
      if (i1 === -1) return;
      var code = p.slice(0, i1).trim().toUpperCase();
      var idStr = i2 === -1 ? p.slice(i1 + 1).trim() : p.slice(i1 + 1, i2).trim();
      var tag = i2 === -1 ? '' : p.slice(i2 + 1).trim().toLowerCase();
      var id = Number(idStr);
      if (code) m[code] = { id: isNaN(id) ? null : id, tag: tag };
    });
    return m;
  }

  function setMsg(box, t, ok) {
    var el = box.querySelector('[data-pd-gift-msg]');
    if (!el) return;
    el.textContent = t;
    el.className = 'form__message ' + (ok ? 'form__message--success' : 'form__message--error');
  }

  function removeGiftIds(ids) {
    if (!ids || !ids.length) return Promise.resolve();
    return fetch(ROOT + 'cart.js')
      .then(r => r.json())
      .then(cart => {
        var updates = {};
        (cart.items || []).forEach(it => {
          if (ids.indexOf(it.variant_id) > -1) updates[it.id] = 0;
        });
        if (Object.keys(updates).length) {
          return fetch(ROOT + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates })
          });
        }
      });
  }

  function localePrefix(){
    var seg=(location.pathname.split('/')[1]||'').toLowerCase();
    var locales=['hu','en','sk'];
    return locales.indexOf(seg)!==-1?'/'+seg:'';
  }

  function goDiscount(code){
    try { localStorage.setItem('gift_try', code); } catch (_) {}
    var prefix = localePrefix();
    var target = prefix + '/cart?discount=' + encodeURIComponent(code);
    location.assign((ROOT || '/').replace(/\/$/,'') + target);
  }

  document.addEventListener('click', async function (e) {
    var btn = e.target.closest('#f-cart-drawer__gift [data-pd-gift-apply]');
    if (!btn) return;
    var box = btn.closest('#f-cart-drawer__gift');

    var input = box.querySelector('#pd-gift-code') || box.querySelector('[data-pd-gift-input]');
    var code = ((input && input.value) || '').trim().toUpperCase();
    if (!code) { setMsg(box, 'Írj be egy kódot.', false); return; }

    var codesMap = parseMap(box.getAttribute('data-codes'));
    var entry = codesMap[code];
    var tags = (box.getAttribute('data-customer-tags') || '').toLowerCase();

    if (!entry) { setMsg(box, 'Ismeretlen kód. Megpróbáljuk alkalmazni kedvezményként…', false); goDiscount(code); return; }

    var eligible = !entry.tag || tags.indexOf(entry.tag) > -1;

    if (!eligible) {
      setMsg(box, 'Ehhez az ajándékhoz nincs jogosultságod. A kedvezményt alkalmazzuk.', false);
      goDiscount(code);
      return;
    }

    if (entry.id) {
      try {
        var r = await fetch(ROOT + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: entry.id, quantity: 1 })
        });
        if (!r.ok) {
          location.href = ROOT + 'cart/add?id=' + encodeURIComponent(entry.id) + '&quantity=1';
          return;
        }
        setMsg(box, 'Az ajándék bekerült a kosaradba.', true);
      } catch (_) {
        location.href = ROOT + 'cart/add?id=' + encodeURIComponent(entry.id) + '&quantity=1';
        return;
      }
    } else {
      setMsg(box, 'Kedvezmény alkalmazása…', true);
    }

    goDiscount(code);
  });

  document.addEventListener('DOMContentLoaded', function () {
    var box = document.getElementById('f-cart-drawer__gift');
    if (!box) return;

    var codesMap = parseMap(box.getAttribute('data-codes'));
    var tags = (box.getAttribute('data-customer-tags') || '').toLowerCase();

    var idsToRemove = Object.values(codesMap)
      .filter(o => o.tag && tags.indexOf(o.tag) === -1)
      .map(o => o.id)
      .filter(Boolean);

    if (idsToRemove.length) removeGiftIds(idsToRemove);
  });
})();
